import React, { Children } from "react";
import classNames from "classnames";
import { Flex, useScreenSize } from "@jsq/ds/core";

type MultiInputFormRowProps = {
  children: React.ReactElement[];
};

/**
 * A component that represents a row with two input fields in a form.
 *
 * @component
 * @example
 * ```tsx
 * <MultiInputFormRow>
 *   <InputField label="First Name" />
 *   <InputField label="Last Name" />
 * </MultiInputFormRow>
 * ```
 */
export const MultiInputFormRow: React.FC<MultiInputFormRowProps> = ({ children }) => {
  const screenSize = useScreenSize();
  const childrenArray = Children.toArray(children);

  return (
    <Flex
      flexDirection={screenSize === "small" ? "column" : "row"}
      alignItems="flex-start"
      className="stacked-lg"
    >
      {childrenArray.map((child, index) => (
        <Flex
          // Disabling this rule because the children order and count will not change dynamically

          key={index}
          flexDirection="column"
          flexGrow={1}
          flexBasis={0}
          className={classNames({
            "inline-lg": screenSize !== "small" && index !== childrenArray.length - 1,
          })}
        >
          {child}
        </Flex>
      ))}
    </Flex>
  );
};
